import styled from "styled-components/macro";

export const StyledMap = styled.div`
  display: block;
  position: relative;
  width: 100%;
`;

export const Controls = styled.div`
  display: flex;
  top: 0;
  right: 0;
  position: absolute;
  z-index: 2;
`;

export const Control = styled.button`
  border: none;
  cursor: pointer;
  background: #f2f2f2;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:first-child {
    margin-right: 10px;
  }
`;

export const ZoomImage = styled.img`
  max-width: 100%;
  height: auto;
`;
